module.exports = __webpack_public_path__ + "static/img/join-bg.8a4e9f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/join-bg.jpg
// module id = qNrj
// module chunks = 1